var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgGift(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M11.28 12.64V21H5.84a1.7 1.7 0 01-1.7-1.7v-6.66h7.14zm8.58 0v6.66a1.7 1.7 0 01-1.7 1.7h-5.45v-8.36h7.15zm-2.25-6.688a1.467 1.467 0 00-1.393-1.517c-1.726 0-2.726 1.763-3.195 2.937l-.054.137-1.668.001v3.69H4.7A1.7 1.7 0 013 9.5v-.29a1.7 1.7 0 011.7-1.7h.66a3.122 3.122 0 01-.42-1.538c-.034-1.586 1.197-2.92 2.843-2.987 1.961 0 3.317 1.271 4.216 3.111.9-1.852 2.24-3.11 4.218-3.11h.061c1.592.067 2.826 1.412 2.782 2.966 0 .561-.153 1.098-.42 1.558h.66a1.7 1.7 0 011.7 1.7v.29a1.7 1.7 0 01-1.7 1.7h-6.6V7.51h3.542c.736-.015 1.368-.726 1.368-1.558zM7.783 4.435A1.467 1.467 0 006.39 5.952c0 .832.632 1.543 1.368 1.558h3.273l-.053-.138c-.47-1.174-1.488-2.937-3.195-2.937z"
  })));
}

export default SvgGift;